import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Layout } from 'components'
import styles from './AdminPage.module.scss'
import right from 'assets/icons/chevron_right.png'
import { getOrganization, getAllCommand } from 'service/AdminService'
import userInfo from 'utils/userInfo'
import Notification from 'utils/Notifications'

const AdminPage = () => {
  const { t } = useTranslation('common')
  // Wave 4: title в табе браузера для страницы администратора организаций.
  useEffect(() => {
    document.title = `${t('admin.fullPage.title_admin', 'Админ')} — ЧУ`
  }, [t])
  const [data, setData] = useState('')
  const [data1, setData1] = useState('')
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const navigate = useNavigate()
  const user = userInfo()

  const getData = async () => {
    try {
      const response = await getOrganization(data)
      const response_command = await getAllCommand(data1)
      setData(response.data)
      setData1(response_command.data)
    } catch (error) {}
  }

  useEffect(() => {
    if (user?.is_admin_of) {
      getData()
    } else {
      navigate('/home/')
    }
    setRender(false)
  }, [render])

  return (
    <Layout>
      {user?.is_admin_of ? (
        <>
          <div className={styles.project__wrapper}>
            <div className={styles.project__header}>
              <div className={styles.title}>
                {t('adminPage.title')}
                <img
                  src={right}
                  alt=""
                  style={{ paddingLeft: '10px', paddingRight: '10px', verticalAlign: 'middle' }}
                />
              </div>
            </div>
            <div className={styles.project__header2}>
              <div className={styles.title2}>
                <h4>{t('adminPage.companies')}</h4>
              </div>
            </div>
            <div className={styles.project__body}>
              <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                  <tr className={styles.table__row}>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.company')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.created')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.administrator')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.teamsCount')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.usersCount')}</span></th>
                  </tr>
                </thead>
                <tbody className={styles.table__body}>
                  {data && data?.map((item) => (
                    <tr className={styles.table__row} style={{ zIndex: '1' }} key={item.id || item.title}>
                      <td className={styles.table__item}><span className={styles.table__title} style={{ fontWeight: '700' }}>{item.title}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.created}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.employee}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.command_count}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.employee_count}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={styles.project__header2}>
              <div className={styles.title2}>
                <h4>{t('adminPage.teams')}</h4>
              </div>
            </div>
            <div className={styles.project__body}>
              <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                  <tr className={styles.table__row}>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.teamName')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.created')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.administrator')}</span></th>
                    <th className={styles.table__item}><span className={styles.table__title}>{t('adminPage.membersCount')}</span></th>
                  </tr>
                </thead>
                <tbody className={styles.table__body}>
                  {data1 && data1?.map((item) => (
                    <tr className={styles.table__row} style={{ zIndex: '1' }} key={item.id || item.name_team}>
                      <td className={styles.table__item}><span className={styles.table__title} style={{ fontWeight: '700' }}>{item.name_team}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.date_create}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.employee_name}</span></td>
                      <td className={styles.table__item}><span className={styles.table__title}>{item.members.length}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Notification notify={notify} setNotify={setNotify} />
        </>
      ) : ''}
    </Layout>
  )
}

export default AdminPage
